/** The orders (Order Writer) module, as the web host sees it. */
import type { WebModule } from '@daka/core/web';
import { CalendarDays, FileSpreadsheet } from 'lucide-react';

import { ORDER_MESSAGES, ORDERS_MANIFEST, ORDERS_ROUTES } from '../domain';

export const ordersWebModule: WebModule = {
   manifest: ORDERS_MANIFEST,
   nav: [
      { labelKey: ORDER_MESSAGES.navOrders, to: ORDERS_ROUTES.LIST, icon: FileSpreadsheet },
      { labelKey: ORDER_MESSAGES.navCalendar, to: ORDERS_ROUTES.CALENDAR, icon: CalendarDays }
   ]
};
